const getCurrentLanguage = (): string => {
	// Check for localized vars.
	const localizedLanguage = (window as any)
		.midtownMembershipsLanguage as Record<string, any>;

	return localizedLanguage?.current_language ?? "en";
};

export default getCurrentLanguage;
